export const subPermissionKeys = {
  groupKey: 'report-dashboard',

  read: 'report-dashboard-listar',  // index
  show: 'permission:report-dashboard-obtener',  // show
  create: 'permission:report-dashboard-crear', // store
  edit: 'permission:report-dashboard-actualizar', // update
  delete: 'permission:report-dashboard-borrar', // destroy
};
